<template>
  <FancyDialog :isPadding="false" v-bind="{ ...$attrs }" v-on="$listeners">
    <v-container fluid class="dialog_container">
      <div
        style="
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 28px;
          align-items: start;
          padding: 0 16px;
        "
      >
        <p class="large-title2-semibold" style="color: #ff9f4b">還沒有寶貝喔</p>
        <p class="body-regular" style="color: #0d0c0c">您需要新增寶貝才可以預約美容喔!</p>
      </div>
      <div style="display: flex; gap: 16px;">
        <Button
          text="返回美容頁"
          class="cancel_btn"
          @click.prevent="clickLeave"
        />
        <Button
          text="新增寶貝"
          bolder
          style="
            background-color: #ff9f4b;
            color: #fff;
            border-radius: 18px;
            padding: 16px;
            width: 50%;
          "
          @click.prevent="handleClick"
        />
      </div>
    </v-container>
  </FancyDialog>
</template>

<script>
import FancyDialog from '@/components/FancyDialog.vue'
import Button from '@/components/Atom/Button.vue'
export default {
  components: {
    FancyDialog,
    Button
  },
  name: 'PopupGeneralAlert',
  props: {
    errorTitle: {
      type: String,
    },
    errorMsg: {
      type: Array,
    },
    serviceList: {
      type: Array,
    },
  },
  emits: ['click:confirm', 'click:back'],
  data: () => ({}),
  methods: {
    handleClick() {
      this.$emit('click:confirm')
    },
    clickLeave(){
      this.$emit('click:back')
    },
  },
}
</script>

<style lang="scss" scoped>
.sure_btn {
  background-color: #ff9f4b;
  color: #fff;
  border-radius: 18px;
  padding: 16px;
  width: 50%;
  &:active {
    background-color: #D16200;
  }
}
.cancel_btn {
  background-color: white;
  color: #ff9f4b;
  border: solid 2px #ff9f4b;
  border-radius: 18px;
  padding: 16px;
  width: 50%;
  &:active {
    background-color: #ff9f4b;
    color: white;
  }
}
div.dialog_container {
  position: relative;
  z-index: 1;
  padding: 32px 16px 24px 16px;
  p.title {
    color: $color_main_first;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: -0.3px;
  }
  p.desc {
    font-size: 14px;
    line-height: 24px;
    color: $color_main_black;
  }
  > .footer {
    .btn {
      height: 50px;
      width: 100%;
      @media screen and (max-width: 374px) {
        max-width: 118px;
      }
      @media screen and (min-width: 375px) {
        max-width: 145.5px;
      }
    }
  }
}
</style>
